var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * FilterLines component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconFilterLines extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.2373 11.2499C5.2373 10.8357 5.57309 10.4999 5.9873 10.4999H18.014C18.4282 10.4999 18.764 10.8357 18.764 11.2499C18.764 11.6641 18.4282 11.9999 18.014 11.9999H5.9873C5.57309 11.9999 5.2373 11.6641 5.2373 11.2499Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.85547 5.61377C1.85547 5.19956 2.19126 4.86377 2.60547 4.86377L21.3955 4.86377C21.8097 4.86377 22.1455 5.19956 22.1455 5.61377C22.1455 6.02798 21.8097 6.36377 21.3955 6.36377L2.60547 6.36377C2.19126 6.36377 1.85547 6.02798 1.85547 5.61377Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.74609 16.886C9.74609 16.4718 10.0819 16.136 10.4961 16.136L13.505 16.136C13.9192 16.136 14.255 16.4718 14.255 16.886C14.255 17.3002 13.9192 17.636 13.505 17.636L10.4961 17.636C10.0819 17.636 9.74609 17.3002 9.74609 16.886Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconFilterLines.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconFilterLines.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconFilterLines.prototype, "size", void 0);
if (customElements.get('cat-icon-filter-lines') === undefined) {
    customElements.define('cat-icon-filter-lines', BlocksIconFilterLines);
}
